import React, { useState, useEffect, useContext } from 'react';
import './Footer.css';
import Weather from '../Weather/Weather';
import statusLogo from '../../assets/status_logo.png';
import SocialIcon from '../SocialIcons/SocialIcon';
import getImageTypeFromBase64 from '../../common/getImageTypeFromBase64';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import viewport from '../../common/viewport';
import StatusFooter from '../StatusFooter/StatusFooter';
import logComponent from '../../common/logComponent';


export default function Footer() {
  const environmentContext = useContext(EnvironmentContext);
  const { organization, activeUser: user } = environmentContext;
  const [viewportIsSm, setViewportIsSm] = useState(viewport.isOldSm());

  if (logComponent('Footer')) { console.debug('Footer rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('Footer')) { console.debug('Footer onMount'); }
    window.addEventListener('resize', checkViewport);
    return function cleanup() {
      window.removeEventListener('resize', checkViewport);
    };
  }, []);

  const checkViewport = () => {
    if (logComponent('Footer')) { console.debug('Footer checkViewport'); }
    if (viewport.isOldSm() !== viewportIsSm) {
      setViewportIsSm(viewport.isOldSm());
    }
  }

  const getOrganizationNameOrLogo = () => {
    if (logComponent('Footer')) { console.debug('Footer getOrganizationNameOrLogo'); }
    const { activeUser: user, organization } = environmentContext;

    // bail if necessary data not loaded yet
    if (!organization && (!user || user.groupTypeString !== 'Status Solutions')) return;

    let organizationWebsiteLink = null;

    if (organization) {
      organizationWebsiteLink = organization.webLinks.find(link => link.Type === 'W');
    }

    if (user.groupTypeString === 'Status Solutions') {
      return (
        <a className="Organization-Footer__organization-link" href="https://www.statussolutions.com" title="Status Solutions website" target="_blank" rel="noopener noreferrer">
          <img src={statusLogo} alt="Status Solutions" />
        </a>
      );
    } else {
      if (organizationWebsiteLink) {
        if (organization.logo) {
          return (
            <a className="Organization-Footer__organization-link" href={organizationWebsiteLink.Url} title={`${organization.name} website`} target="_blank" rel="noopener noreferrer">
              <img
                className="Organization-Footer__logo"
                src={`data:${getImageTypeFromBase64(organization.logo)};base64,${organization.logo}`}
                alt={`Logo for ${organization.name}`} />
            </a>
          );
        } else {
          return (
            <a className="Organization-Footer__organization-link" href={organizationWebsiteLink.Url} title={`${organization.name} website`} target="_blank" rel="noopener noreferrer">
              <p className="Organization-Footer__organization-name">{organization.name}</p>
            </a>
          )
        }
      } else {
        if (organization.logo) {
          return (
            <div className="Organization-Footer__organization-brand">
              <img
                className="Organization-Footer__logo"
                src={`data:${getImageTypeFromBase64(organization.logo)};base64,${organization.logo}`}
                alt={`Logo for ${organization.name}`} />
            </div>
          );
        } else {
          return (
            <div className="Organization-Footer__organization-brand">
              <p className="Organization-Footer__organization-name">{organization.name}</p>
            </div>
          );
        }
      }
    }
  }


  return (
    <footer className="Footer">
      <div className="Organization-Footer">
        {
          user && user.groupTypeString !== 'Status Solutions' &&
          <div className="Organization-Footer__organization">
            <p className="Organization-Footer__intro">Brought to you by:</p>
            {
              getOrganizationNameOrLogo()
            }

          </div>
        }

        {
          user && user.groupTypeString !== 'Status Solutions' &&
          <div className="Organization-Footer__social-icons">
            {

              organization &&
              organization.webLinks &&
              organization.webLinks.map((weblink, index) =>
                <SocialIcon
                  key={index}
                  className="Organization-Footer__social-icon" type={weblink.type} link={weblink.url} />
              )
            }
          </div>
        }
        <div className="Organization-Footer__weather">
          {
            viewportIsSm &&
            <Weather />
          }
        </div>
      </div>
      <StatusFooter />

    </footer>
  );
}

